const pluraliseText = (count, text) => {
  return `${count} ${text}${count > 1 ? 's' : ''}`;
};

export const generateAnnouncementText = ({
  newNotificationsCount,
  newUpdatesCount,
}) => {
  const notificationsVerb = newNotificationsCount > 1 ? 'are' : 'is';
  const updatesVerb = newUpdatesCount > 1 ? 'are' : 'is';

  if (newNotificationsCount && newUpdatesCount) {
    return `There ${notificationsVerb} ${pluraliseText(
      newNotificationsCount,
      'notification'
    )}, and ${pluraliseText(newUpdatesCount, 'update')}`;
  }

  if (newNotificationsCount) {
    return `There ${notificationsVerb} ${pluraliseText(
      newNotificationsCount,
      'notification'
    )}`;
  }
  if (newUpdatesCount) {
    return `There ${updatesVerb} ${pluraliseText(newUpdatesCount, 'update')}`;
  }
};
